import {createContext, useContext} from 'react';
import {sharedIconAssets} from './sharedIconsAssets';

export enum GenericIconName {
  AboutYouKnob = 'AboutYouKnob',
  AddCircleFill = 'AddCircleFill',
  AddToBasket = 'AddToBasket',
  AddToBasketFilled = 'AddToBasketFilled',
  AddToBasketWithCheckMark = 'AddToBasketWithCheckMark',
  AlertError = 'AlertError',
  AlertSuccess = 'AlertSuccess',
  CouponCloud = 'CouponCloud',
  CouponNav = 'CouponNav',
  AlertSuccessFill = 'AlertSuccessFill',
  AlertErrorFill = 'AlertErrorFill',
  AlertErrorCircleFill = 'AlertErrorCircleFill',
  ArrowDown = 'ArrowDown',
  ArrowLeft = 'ArrowLeft',
  ArrowLongRight = 'ArrowLongRight',
  ArrowRight = 'ArrowRight',
  ArrowSmallRight = 'ArrowSmallRight',
  ArrowUp = 'ArrowUp',
  Checkmark = 'Checkmark',
  CheckmarkCircle = 'CheckmarkCircle',
  CheckmarkCircleWhiteCheck = 'CheckmarkCircleWhiteCheck',
  ChevronDown = 'ChevronDown',
  Clock = 'Clock',
  Close = 'Close',
  Coupons = 'Coupons',
  CreditCard = 'CreditCard',
  Discount = 'Discount',
  DoubleArrow = 'DoubleArrow',
  Download = 'Download',
  Dropdown = 'Dropdown',
  EmptySearch = 'EmptySearch',
  Error = 'Error',
  ExternalLink = 'ExternalLink',
  Filter = 'Filter',
  FitAdvisor = 'FitAdvisor',
  Globe = 'Globe',
  GridMultiCol = 'GridMultiCol',
  GridSingleCol = 'GridSingleCol',
  Hashtag = 'Hashtag',
  Heart = 'Heart',
  HeartAdd = 'HeartAdd',
  HeartFilled = 'HeartFilled',
  Help = 'Help',
  Info = 'Info',
  InfoFilled = 'InfoFilled',
  InfoFilledGray = 'InfoFilledGray',
  List = 'List',
  Lock = 'Lock',
  Mail = 'Mail',
  MailBlack = 'MailBlack',
  More = 'More',
  NavBasket = 'NavBasket',
  NavHeaderBasket = 'NavHeaderBasket',
  NavHeaderWishlist = 'NavHeaderWishlist',
  NavHeaderSearch = 'NavHeaderSearch',
  NavUser = 'NavUser',
  ParcelBox = 'ParcelBox',
  Phone = 'Phone',
  Reset = 'Reset',
  Ruler = 'Ruler',
  Search = 'Search',
  SecondHandService = 'SecondHandService',
  Settings = 'Settings',
  Share = 'Share',
  ShareAndroid = 'ShareAndroid',
  SmileyHappy = 'SmileyHappy',
  SmileySad = 'SmileySad',
  SocialWhatsapp = 'SocialWhatsapp',
  Trash = 'Trash',
  USPReturn = 'USPReturn',
  User = 'User',
  UspProofOfQuality = 'UspProofOfQuality',
  UspFreeShipping = 'UspFreeShipping',
  Vip = 'Vip',
  Warning = 'Warning',
  QuestionMark = 'QuestionMark',
  Sale = 'Sale',
  Percent = 'Percent',
  FullscreenOpener = 'FullscreenOpener',
  Pause = 'Pause',
  PauseRound = 'PauseRound',
  Play = 'Play',
  Mute = 'Mute',
  Unmute = 'Unmute',
  YourFiltersHint = 'YourFiltersHint',
  StarFilled = 'StarFilled',
  StarOutline = 'StarOutline',
  AppleIcon = 'IcApple',
  FacebookIcon = 'IcFacebook',
  SearchHistory = 'SearchHistory',
  SaleCloud = 'SaleCloud',
  SaleCloudRTL = 'SaleCloudRTL',
  InfoWithoutFill = 'InfoWithoutFill',
  Bell = 'Bell',
  BellFilled = 'BellFilled',
  DropdownUpRight = 'DropdownUpRight',
  Coupon = 'Coupon',
  NotificationCenterEmptyState = 'NotificationCenterEmptyState',
  BestPriceGuaranteeWallet = 'BestPriceGuaranteeWallet',
  Loudspeaker = 'Loudspeaker',
  Merchant = 'Merchant',
  SustainabilityLeaf = 'SustainabilityLeaf',
  InfoOutline = 'InfoOutline',
  Size = 'Size',
  SaleEvent = 'SaleEvent',
  SmallSaleEvent = 'SmallSaleEvent',
  AppOnlyCoupon = 'AppOnlyCoupon',
  AppOnlyIcon = 'AppOnlyIcon',
  ArrowUpSharpCorners = 'ArrowUpSharpCorners',
  CouponExpired = 'CouponExpired',
  ErrorTriangle = 'ErrorTriangle',
  ErrorTriangleColor = 'ErrorTriangleColor',
  RightArrowSharpEdges = 'RightArrowSharpEdges',
  couponHintCloud = 'couponHintCloud',
  copy = 'copy',
}

export type IconName = keyof typeof sharedIconAssets;

export const iconNamesContext = createContext<
  {[key in IconName]: string} | null
>(null);

export function useSharedIconUrl(iconName: IconName): string {
  const assets = useContext(iconNamesContext);

  if (!assets) {
    throw new Error(
      `Cannot find icon \`${iconName}\`. This is most probably caused because the \`IconsProvider\` is not rendered as a parent of this component.`,
    );
  }

  return assets[iconName];
}
